import axios from 'modules/api-client/request';
import { IPostUTMParamsRequest } from './types';

export const postUTMParams = ({ courseId, utm_source, utm_medium, utm_campaign, action }: IPostUTMParamsRequest) => {
  return axios
    .post<IPostUTMParamsRequest, void>('/utm', { courseId, utm_source, utm_medium, utm_campaign, action })
    .catch(null);
};

